module.exports = __webpack_public_path__ + "media/images/dashboard/payment/visa-card-54d66faff4dd035dc4676f571dd45507.jpeg";